<template>
  <!-- Main content area for the website -->
  <main class="website-main">
    <!-- Top gradient wrapping the featured articles component -->
    <div class="gradient-top">
      <section class="article-detail">
        <div>
          <div class="shape">
            <img
              :src="article.firstCoverUrl"
              :alt="article.headline"
            >
          </div>
          <article class="default-text">
            <a
              href="/"
              class="back-to-index"
            >Zpět na úvod</a>
            <h1>{{ article.headline }}</h1>
            <time :datetime="article.publishedAt">{{ article.publishedAtFormatted }}</time>
            <div
              class="default-text"
              v-html="article.content"
             />
          </article>
        </div>
      </section>
    </div>
  </main>
</template>

<script setup>
import { onMounted, defineProps, computed } from 'vue'
import { useMicrositeStore } from '../stores/useMicrositeStore'

const props = defineProps({
  microsite: {
    type: Object,
    required: true
  },
  article: {
    type: Object,
    required: true
  }
})

const micrositeStore = useMicrositeStore()

onMounted(() => {
  micrositeStore.setMicrosite(props.microsite)
})

const article = computed(() => {
  return props.article
})
</script>
